import React from 'react';
import { motion } from 'framer-motion';

// Capability metrics — framed around what the console does, not fabricated
// adoption numbers. Kept honest until real usage data exists.
const metrics = [
  { value: '1', label: 'Console for your placement cell' },
  { value: 'CSV', label: 'Bulk student import' },
  { value: '24/7', label: 'AI interview availability' },
  { value: 'Live', label: 'Completion & score tracking' },
];

const InstitutionMetricsSection = () => {
  return (
    <section className="border-t border-[var(--lp-line)] bg-white py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {metrics.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className="text-center"
            >
              <p className="text-3xl tracking-tight text-[var(--lp-accent)] sm:text-4xl">{m.value}</p>
              <p className="mt-2 font-mono text-[11px] tracking-wider text-[var(--lp-ink-soft)]">
                {m.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstitutionMetricsSection;
